import React from 'react';
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip
} from '@mui/material';
import { useSuperDuper } from '../context/SuperDuperContext';
import { renderLoading, renderError } from '../components/StatusViews';

const QuizLeadsTab = () => {
  const {
    quizLeads,
    quizLeadsLoading,
    quizLeadsError,
    quizLeadsPage,
    quizLeadsRowsPerPage,
    handleQuizLeadsChangePage,
    handleQuizLeadsChangeRowsPerPage
  } = useSuperDuper();

  return (
    <>
      <Typography
        variant="h4"
        sx={{ mb: { xs: 2, sm: 4 }, fontSize: { xs: '1.35rem', sm: '2.125rem' } }}
      >
        Quiz Leads
      </Typography>

      {quizLeadsLoading ? (
        renderLoading()
      ) : quizLeadsError ? (
        renderError(quizLeadsError)
      ) : (
        <>
          {/* Summary Cards */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom>
                    Total Leads
                  </Typography>
                  <Typography variant="h4">
                    {quizLeads.length}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom>
                    Junior Quiz
                  </Typography>
                  <Typography variant="h4">
                    {quizLeads.filter(lead => lead.quiz_type === 'junior').length}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom>
                    Senior Quiz
                  </Typography>
                  <Typography variant="h4">
                    {quizLeads.filter(lead => lead.quiz_type === 'senior').length}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom>
                    Avg Score
                  </Typography>
                  <Typography variant="h4">
                    {quizLeads.length > 0 
                      ? (quizLeads.reduce((sum, lead) => sum + (lead.percentage || 0), 0) / quizLeads.length).toFixed(1)
                      : 0}%
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Quiz Leads Table */}
          <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Name</strong></TableCell>
                  <TableCell><strong>Phone Number</strong></TableCell>
                  <TableCell><strong>Quiz Type</strong></TableCell>
                  <TableCell><strong>Score</strong></TableCell>
                  <TableCell><strong>Percentage</strong></TableCell>
                  <TableCell><strong>Date</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {quizLeads.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="body2" color="textSecondary" sx={{ py: 3 }}>
                        No quiz leads found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  quizLeads
                    .slice(quizLeadsPage * quizLeadsRowsPerPage, quizLeadsPage * quizLeadsRowsPerPage + quizLeadsRowsPerPage)
                    .map((lead, index) => (
                      <TableRow key={lead._id || index}>
                        <TableCell>{lead.name}</TableCell>
                        <TableCell>{lead.number}</TableCell>
                        <TableCell>
                          <Chip 
                            label={lead.quiz_type === 'junior' ? 'Junior' : 'Senior'} 
                            color={lead.quiz_type === 'junior' ? 'primary' : 'secondary'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          {lead.score !== null && lead.total_questions !== null 
                            ? `${lead.score}/${lead.total_questions}` 
                            : 'N/A'}
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={`${lead.percentage.toFixed(1)}%`}
                            color={
                              lead.percentage >= 80 ? 'success' : 
                              lead.percentage >= 60 ? 'primary' : 
                              lead.percentage >= 40 ? 'warning' : 'error'
                            }
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          {new Date(lead.createdAt).toLocaleDateString('en-IN', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={quizLeads.length}
              rowsPerPage={quizLeadsRowsPerPage}
              page={quizLeadsPage}
              onPageChange={handleQuizLeadsChangePage}
              onRowsPerPageChange={handleQuizLeadsChangeRowsPerPage}
            />
          </TableContainer>
        </>
      )}
    </>
  );
};

export default QuizLeadsTab;
